import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_race_ethnic_group_skin_color_sex_gender_religion_political_1'

export const dataPointDefinition = {
  retracedId: 'have_race_ethnic_group_skin_color_sex_gender_religion_political_1',
  name: 'Have race, ethnic group, skin color, sex (gender), religion, political opinion, national extraction, social origin, disability, HIV/AIDS status, sexual orientation, pregnancy/maternity status, marital status, family responsibilities, age or nationality/foreign migrant worker status been a factor in decisions regarding promotion or access to training?',
  description:
    'Answer Yes if any of these elements are factored into decisions regarding promotion or access to training.\r\r\n',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10720,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
